<template>
  <div class="block block__credit-info"
       @mouseenter="showModal = true"
       @mouseleave="showModal = false"
  >
    <div class="svg svg__theme_credit">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z" fill="#C5C5C9"/>
        <circle cx="9" cy="9" r="1.5" fill="#C5C5C9"/>
        <circle cx="15" cy="15" r="1.5" fill="#C5C5C9"/>
        <rect x="15.5355" y="7.05078" width="2" height="12" rx="1" transform="rotate(45 15.5355 7.05078)" fill="#C5C5C9"/>
      </svg>
    </div>

    <transition name="fade">
      <div class="modal modal__theme_default"
           v-if="showModal"
      >
        На данный тариф доступна беспроцентная рассрочка от банков партнёров
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "BlockInfoCredit",

  data() {
    return {
      showModal: false, // отобразить модальное окно с информацией
    }
  },

  created() {

  },

  mounted() {

  },

  watch: {

  },

  methods: {

  },

  components: {

  }
}
</script>

<style scoped lang="scss">
@import '../../../../style/variables';

.block__credit-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  margin-left: 8px;
  cursor: default;
}

.svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  svg path, svg rect, svg circle {
    transition: $transition_medium;
  }
}

.modal__theme_default {
  display: flex;
  flex-direction: row;
  padding: 14px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08);
  border-radius: 8px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 19px;
  position: absolute;
  left: 0;
  top: 0;
  width: 300px;
  z-index: 2;
}

@media all and (max-width: 1700px) {
  .block__credit-info svg {
    width: auto;
    height: 21px;
  }
}

@media all and (max-width: 1440px) {
  .block__credit-info svg {
    width: auto;
    height: 20px;
  }

  .modal__theme_default {
    padding: 12px;
    border-radius: 8px;
    font-size: 14px;
    line-height: 18px;
    width: 280px;
  }

  .block__credit-info {
    margin-left: 6px;
  }
}

</style>